import { inject, Injectable } from '@angular/core';
import { DataContextService } from '@seahorse/common';
import { SeahorseModule } from '@seahorse/domain';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SeahorseModuleService {
  private readonly _baseUrl = 'customdata/seahorse-modules';

  private _dataContextService = inject(DataContextService);

  getAll(organisationId: string) {
    return this._dataContextService
      .get<SeahorseModule[]>(`${this._baseUrl}/organisation/${organisationId}`)
      .pipe(map((x) => (x.hasResult ? x.result : [])));
  }

  getById(id: number) {
    return this._dataContextService.get<SeahorseModule>(
      `${this._baseUrl}/${id}`
    );
  }

  add(seahorseModule: SeahorseModule) {
    return this._dataContextService.post<SeahorseModule>(
      `${this._baseUrl}`,
      seahorseModule
    );
  }

  update(seahorseModule: SeahorseModule) {
    return this._dataContextService.put<SeahorseModule>(
      `${this._baseUrl}/${seahorseModule.id}`,
      seahorseModule
    );
  }

  delete(id: number) {
    return this._dataContextService.delete<SeahorseModule>(
      `${this._baseUrl}/${id}`
    );
  }
}
